import React, { useEffect, useRef, useState } from 'react';

import { RateInput } from './TaxationSection.style';

const formatarAliquota = (v?: number | null): string =>
  v === null || v === undefined ? '' : String(v).replace('.', ',');

const lerAliquota = (texto: string): number | undefined => {
  const limpo = texto.replace(',', '.').trim();
  if (limpo === '') return undefined;
  const n = Number(limpo);
  return Number.isFinite(n) ? n : undefined;
};

// PATCH rejeita mais de 4 casas decimais (regex do DTO em create-order.dto.ts).
const limitarCasasDecimais = (texto: string, casas = 4): string => {
  const separador = texto.includes(',') ? ',' : texto.includes('.') ? '.' : null;
  if (!separador) return texto;
  const [inteiro, decimal = ''] = texto.split(separador);
  if (decimal.length <= casas) return texto;
  return `${inteiro}${separador}${decimal.slice(0, casas)}`;
};

interface RateCellProps {
  value: number | null | undefined;
  edited: boolean;
  onChange: (value: number | undefined) => void;
}

/**
 * Célula de alíquota: mantém o texto digitado localmente enquanto está em foco
 * (senão a vírgula intermediária some a cada tecla) e ressincroniza do form
 * assim que o valor muda por fora — recotação, troca de natureza — e o campo
 * perde o foco.
 */
const RateCell: React.FC<RateCellProps> = ({ value, edited, onChange }) => {
  const [texto, setTexto] = useState(formatarAliquota(value));
  const emFoco = useRef(false);

  useEffect(() => {
    if (emFoco.current) return;
    setTexto(formatarAliquota(value));
  }, [value]);

  return (
    <RateInput
      inputMode="decimal"
      placeholder="—"
      $edited={edited}
      $empty={value === undefined || value === null}
      value={texto}
      onFocus={() => {
        emFoco.current = true;
      }}
      onBlur={() => {
        emFoco.current = false;
        setTexto(formatarAliquota(value));
      }}
      onChange={(e) => {
        const bruto = limitarCasasDecimais(e.target.value);
        setTexto(bruto);
        onChange(lerAliquota(bruto));
      }}
    />
  );
};

export default RateCell;
